"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProfileSizes = void 0;
const impact_1 = require("../impact");
var ProfileSizes;
(function (ProfileSizes) {
    ProfileSizes["XLARGE"] = "XLARGE";
    ProfileSizes["LARGE"] = "LARGE";
    ProfileSizes["DEFAULT"] = "DEFAULT";
    ProfileSizes["SMALL"] = "SMALL";
})(ProfileSizes = exports.ProfileSizes || (exports.ProfileSizes = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicHJvZmlsZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy90eXBlcy9wcm9maWxlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVBLHNDQUF1QztBQUV2QyxJQUFZLFlBS1g7QUFMRCxXQUFZLFlBQVk7SUFDdEIsaUNBQWlCLENBQUE7SUFDakIsK0JBQWUsQ0FBQTtJQUNmLG1DQUFtQixDQUFBO0lBQ25CLCtCQUFlLENBQUE7QUFDakIsQ0FBQyxFQUxXLFlBQVksR0FBWixvQkFBWSxLQUFaLG9CQUFZLFFBS3ZCIn0=